// The plain words of a node (strings, numbers, arrays and elements' children, in order), for the `title` that an
// ellipsis must carry with its full text (DS §5): a box that may cut its words short names them whole.

import { isValidElement, type ReactNode } from "react";

export function textOf(node: ReactNode): string {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textOf).join("");
  if (isValidElement<{ children?: ReactNode }>(node)) return textOf(node.props.children);
  return "";
}

/** `title` for an ellipsis box: its full words, or nothing when it holds none. */
export function fullTitle(node: ReactNode): string | undefined {
  const text = textOf(node).replace(/\s+/g, " ").trim();
  return text.length > 0 ? text : undefined;
}
